module.exports = __webpack_public_path__ + "static/why-money.15fb8832.jpg";